var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shown
    ? _c(
        "div",
        {
          staticClass: "policy-modal",
          class: { "is-active": _vm.isSpecialist && !_vm.isPolicyConfirmed }
        },
        [
          _c("div", { staticClass: "policy-modal__backdrop" }),
          _vm._v(" "),
          _c("div", { staticClass: "policy-modal__inner" }, [
            _c("div", { staticClass: "input-block" }, [
              _c(
                "label",
                {
                  staticClass:
                    "group-item-checkbox group-item-checkbox--blue-checkbox-border"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checkbox,
                        expression: "checkbox"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.checkbox)
                        ? _vm._i(_vm.checkbox, null) > -1
                        : _vm.checkbox
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.checkbox,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.checkbox = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.checkbox = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.checkbox = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span"),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button button--primary policy-modal__submit",
                attrs: { type: "submit", disabled: _vm.isButtonDisabled },
                on: { click: _vm.submit }
              },
              [_vm._v("\n      Согласен\n    ")]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Подтверждаю\n          "),
      _c(
        "a",
        {
          staticClass: "policy-modal__link",
          attrs: { href: "/specialist-policy/", target: "_blank" }
        },
        [
          _vm._v(
            "\n            согласие на обработку персональных данных\n          "
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }